module.exports = __webpack_public_path__ + "static/media/icon_closeBlack.110176d0.svg";